import api from "../services/api";

export const getCustomerByCnpjPlug = async ({ clientCnpj }) => {
  return await api.get(`cliente/${clientCnpj}`);
};
